import { ACCESS_CONTACT_TYPE } from "./constants"

export const isJobServiceContactMarkAsAccess = mark => {
  if (mark == null) return false
  return mark === ACCESS_CONTACT_TYPE || mark === 1
}

export const isParticipantAccessContact = jobContact => {
  if (!jobContact) return false
  if (jobContact.contactType !== "Participant") return false
  const mark = jobContact.markAs
  return isJobServiceContactMarkAsAccess(mark)
}

export const excludeParticipantAccessContacts = jobContacts => (
  (jobContacts || []).filter(c => !isParticipantAccessContact(c))
)
